import { ENDPOINTS, PLEVEL, DEFAULT_QUERY_PARAMS } from './config'
import OptionsModel from 'models/Options'
import MenusModel from 'models/Menus'

export const getApiUrl = () => {
  return process.env.API_URL
}

export const fetchData = async (url, opt = {}) => {
  let response

  console.log('Fetching data', url)

  const options = {
    ...opt,
    headers: {
      ...opt.headers,
      'Strapi-Response-Format': 'v4',
    },
  }

  try {
    const req = await fetch(url, options)
    response = await req.json()
  } catch (err) {
    console.error(err)
  }

  return response
}

const buildQueryString = (params = {}) => {
  const search = new URLSearchParams()
  const allParams = { ...DEFAULT_QUERY_PARAMS, ...params }

  Object.entries(allParams).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    search.append(key, value)
  })

  return search.toString()
}

export const getPageData = async ({
  entity, id = null
}) => {
  if (!id) throw new Error('Page ID is missing!')

  const baseUrl = getApiUrl()
  const query = buildQueryString({
    pLevel: PLEVEL,
    'filters[id][$eq]': id,
  })
  const url = `${baseUrl}${ENDPOINTS[entity]}?${query}`
  const data = await fetchData(url)

  return data
}

export const getEntity = async ({
  entity,
  params = {},
}) => {
  const baseUrl = getApiUrl()

  let endpoint = ENDPOINTS[entity]
  const queryString = buildQueryString(params)
  if (queryString) endpoint = `${endpoint}?${queryString}`

  const apiURL = `${baseUrl}${endpoint}`

  const data = await fetchData(apiURL)
  data.entity = entity

  return data
}

export const getOptions = async () => {
  const data = await getEntity({
    entity: 'options',
    params: { pLevel: PLEVEL },
  })

  if (!data.data) return {}

  const options = await OptionsModel(data)

  return options
}

export const getMenus = async () => {
  const data = await getEntity({ entity: 'menus' })

  if (!data.data) return {}

  const menus = await MenusModel(data)

  return menus
}

